(function () {
  'use strict';

  var ACTIVE = 'tabs-list-item-active';

  function panelOf(item) {
    var href = item.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return null;
    return document.getElementById(href.slice(1));
  }

  function setup(tabs) {
    var items = [];
    var panels = [];
    var list = tabs.querySelector('.tabs-list');
    if (!list) return;

    Array.prototype.forEach.call(list.querySelectorAll('.tabs-list-item'), function (item) {
      var panel = panelOf(item);
      if (!panel) return;
      items.push(item);
      panels.push(panel);
    });
    if (items.length < 2) return;

    var current = -1;

    function select(idx) {
      if (idx === current) return;
      items.forEach(function (item, i) {
        var on = i === idx;
        item.classList.toggle(ACTIVE, on);
        item.setAttribute('aria-selected', on ? 'true' : 'false');
        panels[i].hidden = !on;
      });
      current = idx;
    }

    list.setAttribute('role', 'tablist');
    items.forEach(function (item, i) {
      item.setAttribute('role', 'tab');
      panels[i].setAttribute('role', 'tabpanel');
      item.addEventListener('click', function (e) {
        e.preventDefault();
        select(i);
      });
    });

    var start = 0;
    items.forEach(function (item, i) {
      if (item.classList.contains(ACTIVE)) start = i;
    });
    if (location.hash) {
      panels.forEach(function (panel, i) {
        if ('#' + panel.id === location.hash) start = i;
      });
    }
    select(start);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.rte .tabs'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
